angular
    .module('sodCommon', [
        'ngLodash',
        'ngRoute',
        'ngSanitize',
        'ngAnimate',
        'uiGmapgoogle-maps',
        'FormBuilder',
        'LayoutBuilder',
        'AsyncPanel',
        'kendo.directives',
        'Controllers',
        'vcRecaptcha',
        'angularModalService',
        'angular-ladda',
        'SodCustomAction',
        'SodTemplates',
        'sod.helper',
        'ngResource',
        'ResourceGenerator',
        'angular-md5',
        '720kb.tooltips',
        'sod-logger',
        'dialog-manager',
        'ActionManager',
        'sodCustomActionsLib',
        'ui.carousel',
        'fauzanKhanQueryBuilder',
    ], ['$interpolateProvider', function ($interpolateProvider) {
        $interpolateProvider.startSymbol('<%');
        $interpolateProvider.endSymbol('%>');
    }]);

angular.module('Controllers', []);
$(document).foundation();
$('.has-tip').foundation();
